import { useCallback, useState } from "react";
export function usePreviewFrame() {
  const [body, setBody] = useState<HTMLElement | null>(null);
  const initialize = useCallback((frame: HTMLIFrameElement | null) => {
    const doc = frame?.contentDocument;
    if (!doc || !doc.head || !doc.body) return;
    doc.head.replaceChildren();
    document
      .querySelectorAll('style, link[rel="stylesheet"]')
      .forEach((node) => doc.head.appendChild(node.cloneNode(true)));
    const base = doc.createElement("base");
    base.href = window.location.origin + "/";
    doc.head.appendChild(base);
    doc.body.style.margin = "0";
    setBody(doc.body);
  }, []);
  return { body, initialize };
}
